import TokenInputController from '@/src/components/Commons/Controllers/TokenInputController/TokenInputController';
import { DelegationEntity, FundWithDetailsEntity, ProtocolEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore, useWalletStore } from '@/src/store';
import { strToHex } from '@/src/lib/MayzSmartDB';
import { TOKEN_GOV_CS, TOKEN_GOV_TN_STR } from '@/src/utils/constants';
import BtnConfirmation from './Controls/BtnConfirmation';
import DelegationStatus from './ControlsPro/DelegationStatus';
import styles from './DelegateForm.module.scss';
import { useMemo } from 'react';

interface DelegateFormProps {
    protocol: ProtocolEntity;
    fund: FundWithDetailsEntity;
    isDeposit: boolean;
    isTokensStoreReady: boolean;
    isAddingTokens: boolean;
    isLoadingDelegation: boolean;
    isLoadedDelegation: boolean;
    delegation: DelegationEntity | undefined;
    isValidInput_TokenGov: boolean;
    setIsValidInput_TokenGov: (isValid: boolean) => void;
    input_TokenGov: bigint;
    isValidTx: boolean;
    isProcessingTx: boolean;
    setShowProcessingTx: (show: boolean) => void;
    setShowUserConfirmation: (show: boolean) => void;
    available_TokenGov_in_Wallet: bigint;
    available_TokenGov_in_Delegation: bigint;
    handleChange_Input_TokenGov: (amount: bigint) => void;
    handleClickToggleDepositWithdraw: () => void;
}

export default function DelegateForm(props: DelegateFormProps) {
    //--------------------------------------
    const tokensStore = useTokensStore();
    const walletStore = useWalletStore();
    //--------------------------------------
    const {
        protocol,
        fund,
        isDeposit,
        isTokensStoreReady,
        isAddingTokens,
        isLoadingDelegation,
        isLoadedDelegation,
        delegation,
        isValidInput_TokenGov,
        setIsValidInput_TokenGov,
        input_TokenGov,
        isValidTx,
        isProcessingTx,
        setShowProcessingTx,
        setShowUserConfirmation,
        available_TokenGov_in_Wallet,
        available_TokenGov_in_Delegation,
        handleChange_Input_TokenGov,
        handleClickToggleDepositWithdraw,
    } = props;
    //--------------------------------------
    const metadata = useMemo(() => tokensStore.getTokenPriceAndMetadata(TOKEN_GOV_CS, strToHex(TOKEN_GOV_TN_STR)), [tokensStore, TOKEN_GOV_CS, TOKEN_GOV_TN_STR]);
    const image = useMemo(() => metadata?.image, [metadata]);
    const decimals = useMemo(() => metadata?.decimals, [metadata]);
    const ticker = useMemo(() => metadata?.ticker, [metadata]);
    //--------------------------------------
    return (
        <div className={styles.formController}>
            <div className={styles.inputController}>
                <TokenInputController
                    CS={TOKEN_GOV_CS}
                    TN_Hex={strToHex(TOKEN_GOV_TN_STR)}
                    ticker={ticker}
                    isTokensStoreReady={isTokensStoreReady}
                    image={image}
                    value={input_TokenGov}
                    setValue={handleChange_Input_TokenGov}
                    min={0n}
                    max={isDeposit === true ? available_TokenGov_in_Wallet : available_TokenGov_in_Delegation}
                    decimals={decimals}
                    isValidInput={isValidInput_TokenGov}
                    setIsValidInput={setIsValidInput_TokenGov}
                />
            </div>

            {walletStore.swProInterface === true && (
                <DelegationStatus
                    fund={fund}
                    isDeposit={isDeposit}
                    isLoadingDelegation={isLoadingDelegation}
                    isLoadedDelegation={isLoadedDelegation}
                    isTokensStoreReady={isTokensStoreReady}
                    delegation={delegation}
                    protocol={protocol}
                    input_TokenGov={input_TokenGov}
                />
            )}

            <BtnConfirmation
                isDeposit={isDeposit}
                fund={fund}
                isLoadingDelegation={isLoadingDelegation}
                isLoadedDelegation={isLoadedDelegation}
                isTokensStoreReady={isTokensStoreReady}
                isAddingTokens={isAddingTokens}
                delegation={delegation}
                amount_TokenGov={input_TokenGov}
                isValidTx={isValidTx}
                isProcessingTx={isProcessingTx}
                setShowProcessingTx={setShowProcessingTx}
                setShowUserConfirmation={setShowUserConfirmation}
            />
        </div>
    );
}
